import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { BreakpointsState } from '../../state/breakpointsState/BreakpointsState';
import { useCommon } from 'src/domains/common/Common';
import { FeatureState } from '../../config/features/featureState/FeatureState';
import { ConfigComponents } from '../../config/features/config';
import { StarRouter } from '../../state/router/StarRouter';
import { MiniGames } from 'src/domains/casino/webview/CasinoGames/mini-games/MiniGames';

export const CasinoMiniMain = observer('CasinoMiniMain', () => {
    const common = useCommon();
    const breakpointsState = BreakpointsState.get(common);
    const featureState = FeatureState.get(common);
    const config = ConfigComponents.get(common).config;

    const desktopVersion = breakpointsState.desktop.isBiggerOrEq;
    const isAllowCasinoInIOSWrapper = featureState.allowCasinoInIOSWrapperNew;
    const router = StarRouter.get(common);
    const isCasino = router.currentView?.name === 'casino';
    const isClosing = config.closureModeWithLogin || config.closureMode || config.midnightMigrationScreen;

    const casinoMini =
        config.casinoMiniGames === true && isAllowCasinoInIOSWrapper && isClosing === false ? <MiniGames /> : null;

    if (desktopVersion === null || desktopVersion === true || isCasino) {
        return null;
    }
    return casinoMini;
});
